<tg-row>
    <tg-col>
        <div class="show-more-text-field-text-container"
            [ngClass]="{ 'show-more-text-field-text-container--max-height': (showAll$ | async) === false }">
            <span #descriptionElement class="show-more-text-field-value show-more-text-field-text">{{ displayText }}</span>
            <div class="show-more-text-field-text-ellipsis"
                [ngClass]="{'show-more-text-field-text-ellipsis--visible': (showAll$ | async) === false}">
                ...
            </div>
        </div>
    </tg-col>
</tg-row>
<tg-row *ngIf="isMoreThanMaxLines$ | async">
    <tg-col>
        <button tgButton2 linkStyle (click)="onShowMore()">
            {{ (showAll$ | async) === false ? 'show more' : 'show less' }}
            <tg-icon-right size="small" name="basic-plus" alt="show more" *ngIf="(showAll$ | async) === false"></tg-icon-right>
            <tg-icon-right size="small" name="basic-minus" alt="show less" *ngIf="showAll$ | async"></tg-icon-right>
        </button>
        <br />
        <br />
    </tg-col>
</tg-row>